import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { InformationFlow } from 'ThreeTerminal_mobile_dynamic';

class HotSpots extends React.PureComponent {
    static propTypes = {
        data: PropTypes.array,
        hotArticles: PropTypes.array,
        articleAd: PropTypes.object,
        recommendAd: PropTypes.object,
    };

    render() {
        const { data, hotArticles, articleAd, recommendAd } = this.props;

        if (data && data.length > 0) {
            for (const item of data) {
                if (item.type === 'doc') {
                    item.type = 'article';
                    item.commentUrl = item.commentsUrl;
                    item.base62Id = item.id.slice(5);
                } else if (item.type === 'phvideo') {
                    item.type = 'video';
                    item.duration = item.phvideo && item.phvideo.length;
                    item.commentUrl = item.commentsUrl;
                    item.base62Id = item.id;
                }

                if (item.specialParam) {
                    item.url = item.specialParam.pcUrl;
                }

                if (item.thumbnail) {
                    item.thumbnails = {
                        image: [
                            {
                                url: item.thumbnail,
                            },
                        ],
                    };
                }
            }
        }

        return (
            <div className={styles.hot_box}>
                <div className={styles.hot_title}>热点新闻</div>
                {hotArticles.length > 0 ? (
                    <Chip id="255166" type="recommend" title="小说推荐位" groupName="热点新闻" content={hotArticles}>
                        <InformationFlow isDisplayLoadingMore={false} ad={[articleAd]} />
                    </Chip>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(HotSpots);
